import { inject, Injectable } from '@angular/core';

import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { HttpClient } from '@angular/common/http';
import { AppLockComponent } from '../modals/app-lock-modal/app-lock.modal';

import {
    ModalController,
} from '@ionic/angular/standalone';

enum Platforms {
    IOS = 'ios',
    ANDROID = 'android',
    WEB = 'web'
}

export interface UpdateVersionInfo {
    platform: string;
    version: string;
    force_update: boolean;
    message?: 'string';
}

@Injectable({
    providedIn: 'root'
})
export class AppVersionService {
    private _http = inject(HttpClient);
    private _isLocked = false;
    private _appVersion?: string;
    private _modalController = inject(ModalController);

    constructor() {
        App.getInfo()
            .then((info) => {
                this._appVersion = info.version;
            })
            .catch(() => {
                console.warn('Web, version checking doesnt work.')
                this._appVersion = 'DEV';
            });
    }

    async checkVersion() {
        if (this._isLocked) {
            return;
        }

        setTimeout(() => {
            this._checkVersion();
        }, 2000);

    }

    private _checkVersion() {
        if (this._appVersion === 'dev') {
            return;
        }

        this._getCurrentVersion()
            .then((response) => this._compareVersions(response))
            .catch((error) => {
                console.log(error.message);
                return error;
            });
    }

    private async _compareVersions(data: any) {
        // console.log('Versiom ==> ', data.version);
        const latest = this._calc(data.version);
        const thisAppVersion = this._calc(this._appVersion || '', Infinity);
        const { platform } = await Device.getInfo();

        if (latest > thisAppVersion) {
            this.presentNewVersionModal({
                ...data,
                platform: platform
            });
        }
    }

    private _calc(version: string, defaultValue = 0): number {
        if (version.indexOf('-') > -1) {
            version = version.split('-')[0];
        }
        const parts = version.split('.').map((part) => Number(part));

        const sum = parts[0] * 1000 + parts[1] * 100 + parts[2];

        return isNaN(sum) ? defaultValue : sum;
    }

    async presentNewVersionModal(options?: UpdateVersionInfo) {
        this._isLocked = true;
        const modal = await this._modalController.create({
            component: AppLockComponent,
            cssClass: 'h-100 w-100 round-0',
            componentProps: {
                ...options
            }
        });

        modal.onDidDismiss().then(() => {
            this._isLocked = false;
        });

        return await modal.present();
    }

    private _getCurrentVersion(): Promise<any> {
        return this._http.get('/version').toPromise();
    }

}
